import { SideMenuI } from '../../shared/interfaces/side-menu.interface';

export const CUSTOMER_SIDE_MENU_ITEMS: SideMenuI[] = [
  {
    title: 'Overview',
    route: 'overview',
    translationPath: 'sideMenu.overview',
    activeIcon: 'svgs/side-menu/active-overview.svg',
    inactiveIcon: 'svgs/side-menu/inactive-overview.svg',
    roles: [],
  },
  {
    title: 'Orders',
    route: 'orders',
    translationPath: 'sideMenu.orders',
    activeIcon: 'svgs/side-menu/active-orders-details.svg',
    inactiveIcon: 'svgs/side-menu/inactive-orders-details.svg',
    roles: [],
  },
  {
    title: 'Support',
    route: 'supports',
    translationPath: 'sideMenu.supportRequests',
    activeIcon: 'svgs/side-menu/active-support.svg',
    inactiveIcon: 'svgs/side-menu/inactive-support.svg',
    roles: [],
  },
  {
    title: 'Wallet',
    route: 'wallet',
    translationPath: 'sideMenu.walletHistory',
    activeIcon: 'svgs/side-menu/active-wallet.svg',
    inactiveIcon: 'svgs/side-menu/inactive-wallet.svg',
    roles: [],
  },
];
